// material-ui
import logo from "assets/images/logo.png";

const Logo = () => {
  // return <img src={logo} alt="bhalo" width="170" style={{ filter: "brightness(0) invert(1)"}}/>;
  return <img src={logo} alt="bhalo" width="170" />;
};

export default Logo;
